export const dataString = (dataState) => {

    dataState = JSON.parse(JSON.stringify(dataState));

    var params = {
        page: (dataState.skip + dataState.take) / dataState.take,
        limit: dataState.take
    }

    if (dataState.sort && Array.isArray(dataState.sort) && dataState.sort[0]) {
        params.sortBy = dataState.sort[0].field;
        params.sortType = dataState.sort[0].dir;
        console.log(dataState.sort[0].field);
    }

    return new URLSearchParams(params).toString();
}
